/**
 * Where the bar's back arrow goes from a learner page off the player (job #48,
 * Tom 2026-09-24: one way back). The arrow means the same thing everywhere —
 * one level up — as it does inside Listening, where it steps from a scene to
 * its pod and from a pod to the list before it leaves. So from inside a group
 * it goes to your groups, from games night to Talk to humans, and only from a
 * top-level page does it go back to learning.
 *
 * Keyed by route name, so a page renamed in the router fails the test beside
 * this file rather than quietly sending the learner to the player.
 */
export const LEARNER_PARENT: Record<string, string> = {
  'talk-to-humans': '/',
  'connect': '/talk',
  'connect-call': '/talk',
  'games-night': '/talk',
  'study-groups': '/',
  'study-group': '/groups',
  'study-group-invite': '/groups',
  'speaking-rooms': '/',
  'speaking-room': '/rooms',
  'learner-profile': '/',
  'learner-brain': '/',
  'learner-inbox': '/', // reached from the Library as often as from /me
}

/** One level up from this learner page; the player when the page is unknown. */
export function learnerParent(routeName: unknown): string {
  return (typeof routeName === 'string' && LEARNER_PARENT[routeName]) || '/'
}
